import { useState, useEffect } from "react";
import "../../components/LeadDataReport/LeadDataReport.css";
import axios from "axios";
import filterIcon from "../../Icons/filterIcon.png";
import SearchIcon from "@mui/icons-material/Search";
import "../../components/PettyCash/PettyCash.css";
import CryptoJS from "crypto-js";

const EstimateListComponent = ({ onTotalChange }) => {
  const [estimateData, setEstimateData] = useState([]);
  const [error, setError] = useState("");
  const baseAPI = process.env.REACT_APP_API_URL;
  const storedToken = JSON.parse(localStorage.getItem("token"));
  const [showFilter, setShowFilter] = useState(false);
  const [filterInput, setFilterInput] = useState("");
  const [filterSelect, setFilterSelect] = useState("");

  // ✅ Fetch all estimates initially
  useEffect(() => {
    fetchEstimateList("", "");
  }, [baseAPI, storedToken]);

  // ✅ Reusable fetch function
  const fetchEstimateList = async (leadId, status) => {
    try {
      const response = await axios.get(
        `${baseAPI}userget/EstimateListDetaile?search_param=${
          leadId || ""
        }&Status=${status || ""}`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      if (response.data?.data?.length > 0) {
        setEstimateData(response.data.data);
        setError("");
        if (onTotalChange) onTotalChange(response.data.data.length);
      } else {
        setEstimateData([]);
        setError("No estimate records found.");
      }
    } catch (err) {
      console.error("Error fetching estimate data:", err);
      setError("Error fetching estimate data.");
    }
  };

  const handleFilterToggle = () => setShowFilter(!showFilter);

  // ✅ Apply filter
  const handleFilter = () => {
    fetchEstimateList(filterInput, filterSelect);
  };

  // ✅ Clear filter and reload all data
  const handleClearFilter = () => {
    setFilterInput("");
    setFilterSelect("");
    fetchEstimateList("", "");
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          paddingBottom: "20px",
        }}
      >
        <button className="filterButton" onClick={handleFilterToggle}>
          <img src={filterIcon} alt="Filter" /> FILTER
        </button>
      </div>

      {/* 🔽 Filter Section */}
      {showFilter && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
            padding: "10px",
            background: "#f5f5f5",
            borderRadius: "8px",
            marginBottom: "20px",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              background: "#f5f5f5",
              borderRadius: "8px",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              placeholder="Lead ID"
              value={filterInput}
              onChange={(e) => setFilterInput(e.target.value)}
              style={{
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                width: "200px",
              }}
            />

            <select
              value={filterSelect}
              onChange={(e) => setFilterSelect(e.target.value)}
              style={{
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                width: "180px",
              }}
            >
              <option value="">Status</option>
              <option value="1">Open</option>
              <option value="2">Close</option>
              <option value="3">Converted</option>
            </select>
          </div>

          <div
            style={{
              display: "flex",
              gap: "10px",
              borderRadius: "8px",
              alignItems: "center",
            }}
          >
            <button
              onClick={handleFilter}
              style={{
                backgroundColor: "#5B489D",
                color: "white",
                border: "none",
                padding: "8px 16px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Apply
            </button>

            <button
              onClick={handleClearFilter}
              style={{
                backgroundColor: "white",
                color: "red",
                border: "none",
                padding: "8px 16px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Clear Filter
            </button>
          </div>
        </div>
      )}

      <div className="headingLeadReport">
        <p>Estimate List</p>
      </div>

      {error && <p style={{ color: "red", paddingLeft: "10px" }}>{error}</p>}

      <div
        className="container-fluid"
        style={{ width: "100%", overflowX: "auto" }}
      >
        <div className="petBreedList">
          <table>
            <thead>
              <tr
                className="petBreedListHeading"
                style={{
                  whiteSpace: "nowrap",
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                }}
              >
                <th>Sr. No</th>
                <th>Lead ID</th>
                <th>Date</th>
                <th>Billing Name</th>
                <th>Customer Name</th>
                <th>Service Type</th>
                <th>Location</th>
                <th>Estimate Number</th>
                <th>Estimate Status</th>
                <th>Estimate Created By</th>
                <th>Estimate Amount</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {estimateData.length > 0 ? (
                estimateData.map((item, idx) => (
                  <tr key={item.estimate_id || idx}>
                    <td>{idx + 1}</td>
                    <td>{item.relocation_id}</td>
                    <td>{item.created_date}</td>
                    <td>{item.billing_name}</td>
                    <td>
                      {item.First_Name} {item.Last_Name}
                    </td>
                    <td>{item.ServiceTypeName}</td>
                    <td>
                      {item.OriginCityName} → {item.DestinationCityName}
                    </td>
                    <td>{item.estimate_id}</td>
                    <td
                      style={{
                        color:
                          item.Status === 1
                            ? "green"
                            : item.Status === 2
                            ? "red"
                            : item.Status === 3
                            ? "blue"
                            : "gray",
                      }}
                    >
                      {item.Status === 1
                        ? "Open"
                        : item.Status === 2
                        ? "Close"
                        : item.Status === 3
                        ? "Converted"
                        : ""}
                    </td>
                    <td>{item.AddedBy_Name}</td>
                    <td>{item.amount_in_inr}</td>
                    <td>
                      <button
                        className="btn btn-primary btn-primary-estimate"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          height: "30px",
                          width: "38px",
                          backgroundColor: item.estimate_attachment
                            ? "#5B489D"
                            : "#f0f0f0",
                          color: item.estimate_attachment ? "white" : "#a0a0a0",
                          borderColor: "#C0C6CC",
                          cursor: item.estimate_attachment
                            ? "pointer"
                            : "not-allowed",
                        }}
                        disabled={!item.estimate_attachment}
                        onClick={() => {
                          if (item.estimate_attachment) {
                            const baseImageURL =
                              process.env.REACT_APP_IMAGE_URL; // ✅ Make sure you set this in your .env file
                            window.open(
                              `${baseImageURL}Images/Documents/${item.relocation_id}/${item.estimate_attachment}`,
                              "_blank"
                            );
                          }
                        }}
                      >
                        <SearchIcon
                          className="icon"
                          style={{
                            color: item.estimate_attachment
                              ? "white"
                              : "#a0a0a0",
                          }}
                        />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="12"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default EstimateListComponent;
